module.exports = __webpack_public_path__ + "static/media/socialMobile2x.aa85109a.png";